import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { FreeMode, Scrollbar, Navigation } from 'swiper/modules';
import { AfishaItem } from './AfishaItem';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ShowSchedulesItem } from './ShowSchedulesItem';

export const SwiperAfisha = ({ items }) => {
    const [showModel, setShowModel] = useState(false)
    const [dateList, setDateList] = useState()
    let [searchParams, SetSearchParams] = useSearchParams();

    const [t] = useTranslation('global')
    const navigate = useNavigate()

    const sizeSlider = () => {
        const itemsSize = items.length
        const result = {
            '@0.00': {
                slidesPerView: 2.5, // 2 полный + 0.2 частично видимого
                centeredSlides: false,
                spaceBetween: 20,
            },
            '@0.75': {
                slidesPerView: 2.5, // 1 полный + 0.5 частично видимого
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.00': {
                slidesPerView: itemsSize > 3 ? 3.2 : itemsSize, // 2 полных + 0.2 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.50': {
                slidesPerView: itemsSize > 3 ? 3.3 : itemsSize, // 2 полных + 0.3 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 40,
            },
            '@2.00': {
                slidesPerView: itemsSize > 4 ? 4.4 : itemsSize, // 2 полных + 0.4 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 50,
            },
        }
        return result
    }

    const setParam = (seoUrl) => {
        console.log(seoUrl)
        searchParams.set("showModal", 'true')
        searchParams.append("selectShow", seoUrl)
        SetSearchParams(searchParams)
    }

    const hideModal = () => {
        setShowModel(false)
        searchParams.delete("selectShow")
        searchParams.delete("showModal")
        SetSearchParams(searchParams)
        setDateList(null)
    }

    useEffect(() => {
        if (searchParams.get('showModal') === 'true') {
            setShowModel(true)
        }
    }, [])

    return (
        <div>
            <Modal
                show={showModel}
                size="md"
                fullscreen={"sm-down"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => hideModal()}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t("afisha.selectdate")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dateList &&
                        <>
                            {dateList.map(item =>
                                <ShowSchedulesItem key={item.id} item={item} />
                            )}
                        </>
                    }
                </Modal.Body>
            </Modal>

            <div style={{
                margin: "0 auto",
                // padding: "0 20px" // Добавляем отступы по бокам
            }}>
                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={30}
                    scrollbar={true}
                    navigation={true}
                    modules={[Scrollbar, FreeMode, Navigation]}
                    className="afisha-swiper justify-content-center"
                    breakpoints={sizeSlider()}
                    // Добавляем отступ слева, чтобы первый слайд не прилипал к краю
                    slidesOffsetBefore={20}
                    slidesOffsetAfter={20}
                >
                    {items.map((item) =>
                        <SwiperSlide key={item.name} className='mb-3 afisha-swiper-slide'>
                            <AfishaItem
                                itemsSize={items.length}
                                setDateList={setDateList}
                                SwiperSlide={SwiperSlide}
                                setShowModel={setShowModel}
                                item={item}
                                setParam={setParam}
                                searchParams={searchParams}
                                hideModal={hideModal} />
                        </SwiperSlide>
                    )}
                </Swiper>
            </div>
        </div>
    )
}